import React from 'react';
import { ChevronRight } from 'lucide-react';

const CTASection = ({ onNavigate }) => {
    return (
        <section className="py-24 relative overflow-hidden">
            {/* Background gradient and effects */}
            <div className="absolute inset-0 bg-gradient-to-b from-blue-900/20 via-slate-800/50 to-slate-900" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-700/10 via-transparent to-transparent" />

            {/* Decorative elements */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />

            {/* Content */}
            <div className="relative z-10 max-w-3xl mx-auto text-center px-6">
                <h2 className="text-4xl font-bold text-white mb-6">
                    Data Is Oil.
                </h2>
                <p className="text-xl text-slate-300 mb-8">
                    Let's have a conversation about your business and explore how we can help.
                    No complex jargon - just simple talk about real results.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => onNavigate('/contact')}
                        className="bg-blue-500 hover:bg-blue-600 px-6 py-3 rounded-lg
                text-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 group"
                    >
                        <span>Free Consultation</span>
                        <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CTASection;